import Vue from 'vue'
import App from '@/App.vue'

// api
import '@/shared/services/api'

// store
import store from '@/shared/store'

// router
import router from '@/shared/router'

// plugins
import '@/shared/plugins'

// layout AdminLTE
import '@/shared/layouts/adminlte'

// filters
import '@/shared/common/filters'

// info do deploy (loga branch/ultimo deploy no console em dev/homolog)
import '@/shared/common/helpers/deployInfo'

import '@/shared/assets/css/main.scss'

// deploy info (loga no console so em dev/homolog)
import '@/shared/common/helpers/deployInfo'

// Configurações do módulo
Vue.prototype.$urlBase = ''
Vue.prototype.$urlExternalFiles = ''

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
